import _ from 'underscore';
import Promise from 'bluebird';
import $ from 'jquery';

import { withUiBlock } from '@bingads-webui/uiblocker';
import { BaseStepView } from '@bingads-webui/steps-wizard';
import headerTemplate from './step-header.pug';
import { ImportFailureDetailsTableView } from './import-failure-details-table';

export class BaseImportStep extends BaseStepView {
  initialize({
    deps,
  }) {
    this.deps = deps;
    this.i18n = this.deps.i18n;
    this.i18nAmdLoader = this.deps.i18nAmdLoader;
    this.repository = this.deps.repository;
    this.isEdited = true;
    this.alreadySubmitted = false;
    this.previousStepName = this.deps.previousStepName;
    this.linkTextForTitle = this.deps.linkTextForTitle;
    this.isForVNext = this.deps.isForVNext;
  }

  logTrace(...args) {
    this.repository.logTrace(...args);
  }

  logError(...args) {
    this.repository.logError(...args);
  }

  // usually in continue import, only show active title as summary info is not available.
  // but for accout title step, this step will be already shown as summarry.
  buildTitle(options, ignoreContinueCheck = false) {
    let activeTitle;
    let summaryTitle;

    if (_.isString(options)) {
      activeTitle = options;
    } else if (!ignoreContinueCheck && this.deps.isContinueImport) {
      ({ activeTitle } = options);
    } else {
      ({ activeTitle } = options);
      ({ summaryTitle } = options);
    }

    if (summaryTitle) {
      return {
        done: {
          html: headerTemplate({
            title: summaryTitle,
            subTitle: this.getSummaryInfo(),
            link: this.linkTextForTitle,
          }),
        },
        active: {
          html: headerTemplate({
            title: activeTitle,
          }),
        },
        pending: {
          html: headerTemplate({
            title: activeTitle,
          }),
        },
      };
    }

    return {
      html: headerTemplate({
        title: activeTitle,
      }),
    };
  }

  getSummaryInfo() {
    return '';
  }

  goBack() {
    if (this.deps.referrer) {
      this.repository.navigateToUrl(this.deps.referrer);
    } else if (this.deps.isMultiAccountImport) {
      this.repository.redirectToAccountsSummary();
    } else {
      this.repository.redirectToCampaigns();
    }
  }

  cancel() {
    if (_.propertyOf(this.getState())('importId')) {
      this.logTrace('import will be cancelled.');
      this.repository.cancelCurrentImport(this.getState().importId)
        .then(() => {
          this.goBack();
        })
        .catch(() => {
          this.handleGenericError();
        })
        .finally(withUiBlock());
    } else {
      this.logTrace('cancel is clicked and go back.');
      this.goBack();
    }
  }

  get actions() {
    return [
      {
        name: 'continue-with-edit',
        displayText: this.i18n.get('CampaignImport_ButtonContinue'),
        method: 'continueWithEditLogic',
        enabled: true,
        htmlAttributes: {
          class: 'btn btn-primary',
        },
      },
      {
        name: 'cancel',
        displayText: this.i18n.get('CampaignImport_ButtonCancel'),
      },
    ];
  }

  willHide() {
    this.isEdited = false;
  }

  continueWithEditLogic() {
    if (this.isEditedOrFirstSubmit) {
      Promise.resolve(this.wizardShouldGoNext())
        .then((goNext) => {
          if (goNext) {
            this.trigger('next');
            this.alreadySubmitted = true;
          }
        });
    } else {
      this.trigger('edit:false');
    }
  }

  handleGenericError(err) {
    this.repository.logException(err);
    this.showErrorMessage(this.repository.getLocalizedErrorMessage());
  }

  showErrorMessage(msg) {
    this.deps.alertCenter.showError(msg);
  }

  handleErrorInImport(err) {
    const customized = err.customized || {};
    const { errorCode } = customized;
    this.logTrace(`Handling error in import.  Error code: ${errorCode}  Error message: ${customized.message || 'No error message'}`);

    if (errorCode === 17015 && this.$('.error-panel').length) {
      this.importFailureDetailsTableView = new ImportFailureDetailsTableView({
        message: customized.message,
        data: customized.errorDetail,
        failureReason: errorCode,
        i18n: this.i18n,
        i18nAmdLoader: this.i18nAmdLoader,
        isForVNext: this.isForVNext,
      }).render();

      this.$('.error-panel').html(this.importFailureDetailsTableView.el);
    } else if (customized.message) {
      this.showErrorMessage(customized.message);
    } else {
      this.handleGenericError(err);
    }
    $('.btn-primary').attr('disabled', 'disabled');
    this.trigger('import:error');
  }

  updateAction() {
    // force a re-draw of the action bar in case actions change
    this.trigger('change:action');
  }

  checkIfShouldUpdateAndResetFlagIfTrue() {
    const state = this.getState() || {};

    if (!state.isEditEnabledForWizard) {
      return true;
    }

    let checkResult = true;

    if (this.previousStepName) {
      const key = `${this.previousStepName}.isEdited`;
      const shouldUpdate = _.propertyOf(this.getState())(key);

      if (shouldUpdate) {
        this.patchState({
          [key]: false,
        });
      }

      checkResult = shouldUpdate;
    }

    this.isEdited = checkResult;
    return checkResult;
  }

  get isEditedOrFirstSubmit() {
    const state = this.getState() || {};

    if (!state.isEditEnabledForWizard) {
      return true;
    }
    return !this.alreadySubmitted || this.isEdited;
  }
}
